import React, { Component } from "react";
import Button from "./Buttons";
import ImageDownloader from "./downloadImage";

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSelected: this.props.isSelected,
      selectedFile: this.props.selectedFile,
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.isSelected || newProps.selectedFile || !newProps.isSelected) {
      // console.log(newProps.selectedFile);
      this.setState({
        selectedFile: newProps.selectedFile,
        isSelected: newProps.isSelected,
      });
    }
  }
  render() {
    const { language, rounded, filebase64, compressionProgress } = this.props;
    let classes =
      rounded && rounded === "true" ? "uploadSVG rounded" : "uploadSVG";
    const removeTitle = language === "ar" ? "تعديل الصورة" : "Edit image";
    const filenameTitle = language === "ar" ? "اسم الملف" : "File name";
    const filesizeTitle = language === "ar" ? "حجم الملف" : "File size";
    const progressTitle = language === "ar" ? "جار التحميل" : "Uploading";
    return (
      <React.Fragment>
        <Button
          // id="uploadSVG"
          type="button"
          // classes="uploadSVG"
          classes={classes}
          title={this.props.title}
          dataTestid="widgetButtonBody"
          action={this.props.btnChangeHandler}
          areaLabel={this.props.title}
          svg="true"
          disabled=""
        >
          {this.props.title}{" "}
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              xmlns="http://www.w3.org/2000/svg"
              fill="#ffffff"
              d="M8,16.2C7,16.2,6,16,5,15.6c-0.9-0.4-1.8-1-2.5-1.7c-0.7-0.7-1.3-1.5-1.7-2.5c-0.4-0.9-0.6-1.9-0.6-3  c0-1.1,0.2-2.1,0.6-3c0.4-0.9,1-1.8,1.7-2.5C3.3,2.3,4.1,1.8,5,1.4C6,1,7,0.8,8,0.8s2.1,0.2,3,0.6c0.9,0.4,1.8,1,2.5,1.7  c0.7,0.7,1.3,1.5,1.7,2.5c0.4,0.9,0.6,1.9,0.6,3c0,1.1-0.2,2.1-0.6,3c-0.4,0.9-1,1.8-1.7,2.5c-0.7,0.7-1.5,1.3-2.5,1.7  C10.1,16,9.1,16.2,8,16.2z M8,12.5c0.2,0,0.5-0.1,0.6-0.2c0.2-0.2,0.3-0.4,0.3-0.6V8.4L8.8,6.9l0.6,0.8l0.8,0.8  c0.1,0.2,0.3,0.2,0.6,0.2c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.6L8.8,4.8C8.6,4.6,8.3,4.5,8,4.5  c-0.3,0-0.5,0.1-0.7,0.3L4.8,7.4C4.7,7.6,4.6,7.8,4.6,8c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2  l0.8-0.9l0.6-0.8L7.2,8.4v3.3c0,0.2,0.1,0.4,0.2,0.6C7.6,12.4,7.8,12.5,8,12.5z"
            />
          </svg>
        </Button>
        {/* <input id={Date.now()} value={this.props.filevalue} type="file" name={`file${Date.now()}`} accept={this.props.acceptFormat} onChange={this.props.changeHandler} className="uploadFileInput1" /> */}
        <input
          id={Date.now()}
          type="file"
          name={`file${Date.now()}`}
          accept={this.props.acceptFormat}
          onChange={this.props.changeHandler}
          className="uploadFileInput1"
        />
        {this.state.isSelected ? (
          <div className="text-light">
            <p>
              {filenameTitle}: {this.state.selectedFile.name}
            </p>
            {/* <p>Filetype: {this.state.selectedFile.type}</p> */}
            {/* <p className="Tnumber">Size in bytes: {this.state.selectedFile.size}</p> */}
            {compressionProgress === 100 && (
              <>
                <p className="Tnumber">
                  {filesizeTitle}:{" "}
                  {(this.state.selectedFile.size / (1024 * 1024)).toFixed(2)} MB
                </p>
                <p className="removeLink" onClick={this.props.btnChangeHandler}>
                  {removeTitle}
                </p>
              </>
            )}
            <input
              id={`reupload${Date.now()}`}
              type="file"
              name={`reupload-file${Date.now()}`}
              accept={this.props.acceptFormat}
              onChange={this.props.changeHandler}
              className="uploadFileInput1"
            />
            {/* <p className="removeLink" onClick={this.props.removeFileHandler}><span className="Tnumber">x</span> Remove</p> */}
            {compressionProgress > 0 && compressionProgress < 100 && (
              <div
                className={`compression-progress${
                  language === "ar" ? " revert" : ""
                }`}
              >
                {progressTitle}
              </div>
              // <div className={`compression-progress${language==='ar'?' revert':''}`}>{progressTitle}: {compressionProgress.toFixed()}%</div>
            )}
          </div>
        ) : null
        // <p>Select a file to show details</p>
        }
        {/* {filebase64!=="" && 
            <ImageDownloader base64Code={filebase64} />
        } */}
      </React.Fragment>
    );
  }
}
UploadFile.propTypes = {
  title: React.propTypes.node,
  rounded: React.propTypes.node,
  changeHandler: React.propTypes.node,
  isSelected: React.propTypes.node,
  selectedFile: React.propTypes.node,
  btnChangeHandler: React.propTypes.node,
  removeFileHandler: React.propTypes.node,
  acceptFormat: React.propTypes.node,
  filevalue: React.propTypes.node,
};
export default UploadFile;
